// src/components/AddZonededefense.js
import React, { useState } from 'react';
import axios from '../helpers/axiosConfig';

const AddZonededefense = () => {
  const [formData, setFormData] = useState({
    name: '',
    libelle: '',
    observation: '',
    file: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('name', formData.name);
    data.append('libelle', formData.libelle);
    data.append('observation', formData.observation);
    if (formData.file) data.append('filename', formData.file);

    try {
      await axios.post('/zonededefenses/add', data);
      alert('Zone de défense ajoutée avec succès');
    } catch (error) {
      console.error("Erreur lors de l'ajout de la zone de défense:", error);
    }
  };

  return (
    <div className="container mt-5 pt-5">
      <form onSubmit={handleSubmit}>
        <div className="row ">
          <div className="col form-group ">
            <label htmlFor="">Nom : </label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Nom" required className="form-control" />
            <label htmlFor="">Libellé : </label>

            <input type="text" name="libelle" value={formData.libelle} onChange={handleChange} placeholder="Libellé" className="form-control" />
          </div>
        </div>
        <div className="row">
          <div className="col form-group">
            <label htmlFor="">Observation : </label>

            <textarea name="observation" value={formData.observation} onChange={handleChange} placeholder="Observation" className="form-control" />
            <label htmlFor="">Images : </label>

            <input type="file" name="filename" onChange={handleChange} className="form-control" />
          </div>
        </div>

        <button type="submit">Ajouter</button>
      </form>
    </div>
  );
};

export default AddZonededefense;
